import { render, staticRenderFns } from "./DishView.vue?vue&type=template&id=4cd4d662&scoped=true"
import script from "./DishView.vue?vue&type=script&lang=js"
export * from "./DishView.vue?vue&type=script&lang=js"
import style0 from "./DishView.vue?vue&type=style&index=0&id=4cd4d662&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cd4d662",
  null
  
)

export default component.exports